import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { base64 } from '../../../../Constants/ConstantJS';
import { useDispatch, useSelector } from 'react-redux';
import {
  createBookAction,
  createVolumeAction,
  getBookVolumesAction,
  getBookVolumesData,
  getSingleBookAction,
  getSingleBookData,
  updateBookAction,
  updateSingleVolumesAction,
} from '../../../../module/action/Book';
import Spinner from '../../../../Constants/Spinner';
import { URLToFile } from '../../../../module/ConstantFunctions';
import UploadIcon from '../../../../Assets/Icons/UploadIcon';
import UploadBookIcon from '../../../../Assets/Icons/UploadBookIcon';
import NextIcon from '../../../../Assets/Icons/NextIcon';
import PlusBoxIcon from '../../../../Assets/Icons/PlusBoxIcon';
import TicIcon from '../../../../Assets/Icons/TicIcon';
import EditIcon from '../../../../Assets/Icons/EditIcon';
import BackIcon from '../../../../Assets/Icons/BackIcon';
import { toast } from 'react-toastify';
import { assetURL } from '../../../../api/utils';

const StepOne = ({
  setBookName,
  setUploadedImage,
  setUploadedImageName,
  setBookDetail,
  uploadedImageName,
  uploadedImage,
  bookDetail,
  bookName,
  setStepCount,
  setUploadedLogo,
  setUploadedLogoName,
  uploadedLogo,
  uploadedLogoName,
  editState,
  updateBook,
  addBook,
}) => {
  const [img, setImg] = useState(false);
  const [imgLogo, setImgLogo] = useState(false);
  const createBookLoader = useSelector(e => e.Book.createBookLoader);

  useEffect(() => {
    if (uploadedImage) {
      (async () => {
        let b = await base64(uploadedImage);
        setImg(b);
      })();
    } else {
      setImg(false);
    }
  }, [uploadedImage]);

  useEffect(() => {
    if (uploadedLogo) {
      (async () => {
        let b = await base64(uploadedLogo);
        setImgLogo(b);
      })();
    } else {
      setImgLogo(false);
    }
  }, [uploadedLogo]);

  const [nextButtonDisable, setNextButtonDisable] = useState(true);
  useEffect(() => {
    if (bookDetail.banner && bookDetail.bookName) {
      setNextButtonDisable(false);
    }
  }, [bookDetail]);

  return (
    <div className="">
      <div className=" bg-[#f5f5f5] rounded-lg w-full  p-[32px]  mt-11">
        <div className=" w-full">
          <div className="mb-4">
            <p className="text-sm text-black font-semibold">Book Name</p>
            <input
              value={bookName}
              placeholder="Write name here"
              className="rounded-xl mt-[12px]  w-full h-[56px] px-6 outline-none text-[#7b867c] text-sm font-[Poppins-Medium]"
              onChange={ev => {
                setBookName(ev.target.value);
              }}
            />
          </div>
          <div className="flex justify-between flex-wrap">
            <div className="mb-0">
              <p className="text-sm text-black font-semibold">Book Cover</p>
              <div className="flex mt-[12px] justify-between w-fit sm:flex-row flex-col">
                {img ? (
                  <div className="w-[223px] h-[314px]">
                    <img className="w-full h-full" src={img} />
                  </div>
                ) : (
                  <div className="w-[223px]  h-[314px] border-[2px] border-[#2a9134] rounded-xl flex  items-center justify-center">
                    <UploadBookIcon className="text-[50px] text-[#2a9134]" />
                  </div>
                )}
                <div className="sm:ml-[30px] sm:mt-[30px] mt-2 sm:block flex justify-between">
                  <p className="mb-[16px] sm:w-auto w-1/2 text-sm  text-[#7B867C] font-[Poppins-Medium]">
                    Select cover from <br /> your computer
                  </p>
                  <label className="relative text-[#2a9134] sm:w-auto w-1/2">
                    <input
                      type="file"
                      accept=".JPEG,.JPG,.jpg,.png"
                      className="hidden w-0 absolute"
                      onChange={ev => {
                        if (ev.target.files && ev.target.files[0]) {
                          setUploadedImage(ev.target.files[0]);
                          setUploadedImageName(ev.target.files[0]?.name);
                          let obj = { ...bookDetail };
                          obj.bookName = bookName;
                          obj.banner = ev.target.files[0];
                          setBookDetail(obj);
                        }
                      }}
                    />
                    <div className="flex items-center justify-center mb-[16px] rounded-xl text-[#2a9134] font-semibold py-3.5 px-8 border-[1px] border-[#2a9134] bg-white">
                      <UploadIcon className="mr-1.5" />
                      Upload
                    </div>
                    {/* {uploadedImageName ? */}
                    <p className=" text-black text-sm font-semibold">
                      {uploadedImageName ? uploadedImageName.slice(0, 15) : ''}
                    </p>
                    {/* : null} */}
                  </label>
                </div>
              </div>
            </div>

            <div className="mb-0">
              <p className="text-sm text-black font-semibold">Book Logo</p>
              <div className="flex mt-[12px] justify-between w-fit sm:flex-row flex-col">
                {imgLogo ? (
                  <div className="w-[223px] h-[314px]">
                    <img className="w-full h-full" src={imgLogo} />
                  </div>
                ) : (
                  <div className="w-[223px]  h-[314px] border-[2px] border-[#2a9134] rounded-xl flex  items-center justify-center">
                    <UploadBookIcon className="text-[50px] text-[#2a9134]" />
                  </div>
                )}
                <div className="sm:ml-[30px] sm:mt-[30px] mt-2 sm:block flex justify-between">
                  <p className="mb-[16px] sm:w-auto w-1/2 text-sm  text-[#7B867C] font-[Poppins-Medium]">
                    Select Logo from <br /> your computer
                  </p>
                  <label className="relative text-[#2a9134] sm:w-auto w-1/2">
                    <input
                      type="file"
                      accept=".JPEG,.JPG,.jpg,.png"
                      className="hidden w-0 absolute"
                      onChange={ev => {
                        if (ev.target.files && ev.target.files[0]) {
                          setUploadedLogo(ev.target.files[0]);
                          setUploadedLogoName(ev.target.files[0]?.name);
                          let obj = { ...bookDetail };
                          obj.logoName = bookName;
                          obj.logo = ev.target.files[0];
                          setBookDetail(obj);
                        }
                      }}
                    />
                    <div className="flex items-center justify-center mb-[16px] rounded-xl text-[#2a9134] font-semibold py-3.5 px-8 border-[1px] border-[#2a9134] bg-white">
                      <UploadIcon className="mr-1.5" />
                      Upload
                    </div>
                    <p className=" text-black text-sm font-semibold">
                      {uploadedLogoName ? uploadedLogoName.slice(0, 15) : ''}
                    </p>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {editState ? (
        <>
          <div className="flex items-center">
            <button
              className="mt-6 px-[90px] mr-4 rounded-xl bg-[#2a9134] disabled:bg-[#2a91349c] text-white py-3.5 flex items-center justify-center"
              onClick={() => updateBook()}>
              <TicIcon className="mr-1.5" stroke="#fff" />
              Update
            </button>

            <button
              className="flex mt-6 items-center justify-center  rounded-xl text-[#2a9134] font-semibold py-3.5 px-8 border-[1px] border-[#2a9134] bg-white"
              onClick={() => setStepCount(2)}>
              <EditIcon width={26} height={24} fill="#2a9134" className="mr-[6px]" />
              Update Volumes
            </button>
          </div>
        </>
      ) : (
        <button
          disabled={createBookLoader}
          className="relative mt-6 px-[90px] rounded-xl bg-[#2a9134] disabled:bg-[#2a91349c] text-white py-3.5 flex items-center justify-center"
          onClick={() => addBook()}>
          {createBookLoader ? <Spinner /> : null}

          <span
            className={
              createBookLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'
            }>
            Next <NextIcon className="ml-[6px]" />
          </span>
        </button>
      )}
    </div>
  );
};

const StepTwo = ({
  volumes,
  setVolumes,
  AddMoreVolume,
  allVolume,
  setAllVolume,
  bookDetail,
  bookName,
  addVolumes,
  editState,
}) => {
  const getAllSearchPost = useSelector(e => e.Book.getAllSearchPost);
  const createVolumeLoaderNumber = useSelector(e => e.Book.createVolumeLoaderNumber);
  const [allVolumeData, setAllVolumeData] = useState({});
  const [index, setIndex] = useState('');
  useEffect(() => {
    if (volumes.length) {
      volumes.map((a, i) => {
        if (a.all_in_one) {
          setAllVolumeData(a);
          setIndex(i);
        }
      });

      setAllVolumeData(volumes.filter(obj => obj.all_in_one)[0]);
    }
  }, [volumes]);

  return (
    <div className="w-full mt-11 flex justify-between sm:flex-row flex-col">
      <div className="sm:w-[calc(50%-15px)] w-full">
        {volumes.map((a, i) => {
          return a.volumne_number !== 0 ? (
            <div className=" bg-[#f5f5f5] w-full p-[32px] mb-4  rounded-[10px]" key={i}>
              <div className=" w-full">
                <div className="mb-4">
                  <p className="text-sm text-black font-semibold">Volume {a.volumne_number}</p>
                  <input
                    value={volumes[i].volume_name}
                    placeholder="Write title here"
                    className="rounded-xl mt-[12px] text-[14px]  w-full h-[56px] px-6 outline-none text-[#7b867c]"
                    onChange={ev => {
                      if (editState) {
                        let arr = [...volumes];
                        arr.splice(i, 1, {
                          ...a,
                          volume_name: ev.target.value,
                          edited: true,
                        });
                        setVolumes(arr);
                      } else {
                        let arr = [...volumes];
                        arr.splice(i, 1, {
                          ...a,
                          volume_name: ev.target.value,
                          edited: false,
                        });
                        setVolumes(arr);
                      }
                    }}
                  />
                </div>
              </div>
              <div className=" w-full">
                <div className="mb-3">
                  <p className="text-sm text-black font-semibold">PDF File</p>
                  <p className="text-sm text-[#7b867c]  mt-2">Select PDF file from your computer</p>
                  <label className="relative text-[#2a9134] flex mt-3 items-center">
                    <input
                      type="file"
                      accept=".pdf"
                      className="hidden w-0 absolute"
                      onChange={ev => {
                        if (ev.target.files && ev.target.files[0]) {
                          if (editState) {
                            let arr = [...volumes];
                            arr.splice(i, 1, {
                              ...a,
                              pdf_file: ev.target.files[0],
                              pdfName: ev.target.files[0].name,
                              edited: true,
                              all_in_one: false,
                            });
                            setVolumes(arr);
                          } else {
                            let arr = [...volumes];
                            arr.splice(i, 1, {
                              ...a,
                              pdf_file: ev.target.files[0],
                              pdfName: ev.target.files[0].name,
                              edited: false,
                              all_in_one: false,
                            });
                            setVolumes(arr);
                          }
                        }
                      }}
                    />
                    <div className="flex w-[150px] items-center justify-center mr-4 rounded-xl text-[#2a9134] font-semibold py-3.5 px-8 border-[1px] border-[#2a9134] bg-white">
                      <UploadIcon className="mr-1.5" />
                      Upload
                    </div>
                    {/* {a.pdfName ? */}
                    <p className="text-black text-sm font-semibold ">
                      {a.pdf_file && typeof a.pdf_file === 'string'
                        ? a.pdf_file.slice(0, 8) + '....' + a.pdf_file.slice(a.pdf_file.length - 8)
                        : a.pdfName
                        ? a.pdfName.slice(0, 8) + '....' + a.pdfName.slice(a.pdfName.length - 8)
                        : 'PDF Name.pdf'}
                    </p>
                    {/* : null} */}
                  </label>
                </div>
              </div>
            </div>
          ) : null;
        })}
        <button
          className="font-[600] text-base flex justify-center items-center bg-gray-100 w-full py-4 rounded-xl mb-2 px-[53px]"
          onClick={AddMoreVolume}>
          <PlusBoxIcon svgProp={{ className: 'mr-2' }} pathProp={{ stroke: '#000' }} />
          New Volume
        </button>
      </div>
      <div className="sm:w-[calc(50%-15px)] w-full">
        <div className=" bg-[#f5f5f5] w-full p-[32px] mb-4  rounded-[10px]">
          <div className=" w-full">
            <div className="mb-4">
              <p className="text-sm text-black font-semibold">All Volumes in 1 PDF File</p>
              <input
                value={allVolumeData?.volume_name}
                placeholder="Write title here"
                className="rounded-xl mt-[12px] text-[14px] w-full h-[56px] px-6 outline-none text-[#7b867c]"
                onChange={ev => {
                  // let arr = [...volumes]

                  let obj = {
                    volume_name: ev.target.value,
                    edited: true,
                    all_in_one: true,
                    volumne_number: 0,
                  };
                  if (editState) {
                    let arr = [...volumes];
                    if (allVolumeData) {
                      arr.splice(index, 1, {
                        ...allVolumeData,
                        ...obj,
                        volumne_number: 0,
                      });
                    } else {
                      // arr.push(obj);
                      setAllVolume(obj);
                      // setIndex(arr.length);
                    }
                    setVolumes(arr);
                  } else {
                    let arr = [...volumes];
                    arr.splice(index, 1, {
                      ...allVolumeData,
                      ...obj,
                      volumne_number: 0,
                    });
                    setVolumes(arr);
                  }
                  // setVolumes(arr)
                }}
              />
            </div>
          </div>
          <div className=" w-full">
            <div className="mb-3">
              <p className="text-sm text-black font-semibold">PDF File</p>
              <p className="text-sm text-[#7b867c]  mt-2">Select PDF file from your computer</p>
              <label className="relative text-[#2a9134] flex mt-3 items-center">
                <input
                  type="file"
                  accept=".pdf"
                  className="hidden w-0 absolute"
                  onChange={ev => {
                    if (ev.target.files && ev.target.files[0]) {
                      if (editState) {
                        let obj = {
                          pdf_file: ev.target.files[0],
                          pdfName: ev.target.files[0].name,
                          edited: true,
                          all_in_one: true,
                        };
                        let arr = [...volumes];
                        if (allVolumeData) {
                          arr.splice(index, 1, {
                            ...allVolumeData,
                            ...obj,
                          });
                        } else {
                          // arr.push(obj);
                          setAllVolume({ ...obj, ...allVolume });
                          // setIndex(arr.length);
                        }
                        setVolumes(arr);
                      } else {
                        let arr = [...volumes];
                        arr.splice(index, 1, {
                          ...allVolumeData,
                          pdf_file: ev.target.files[0],
                          pdfName: ev.target.files[0].name,
                          all_in_one: true,
                          edited: false,
                        });
                        setVolumes(arr);
                      }
                    }
                    // let arr = [...volumes]
                    // arr.splice(0, 1, {
                    //     ...arr[0],
                    //     // pdf_file: ev.target.files[0],
                    //     pdfName: ev.target.files[0].name
                    // })
                    // setVolumes(arr)
                  }}
                />
                <div className="flex w-[150px] items-center justify-center mr-4 rounded-xl text-[#2a9134] font-semibold py-3.5 px-8 border-[1px] border-[#2a9134] bg-white">
                  <UploadIcon className="mr-1.5" />
                  Upload
                </div>
                {/* {allVolume.pdfName ? */}
                <p className="text-black text-sm font-semibold ">
                  {allVolumeData && allVolumeData.pdf_file && typeof allVolumeData.pdf_file === 'string'
                    ? allVolumeData.pdf_file
                    : (allVolumeData &&
                        allVolumeData.pdfName &&
                        allVolumeData.pdfName.slice(0, 8) +
                          '....' +
                          allVolumeData.pdfName.slice(allVolumeData.pdfName.length - 8)) ||
                      'PDF Name.pdf'}
                </p>
                {/* // <p className='text-black text-sm font-medium'>{allVolume.pdfName}</p> */}
                {/* : null} */}
              </label>
            </div>
          </div>
        </div>
        {/* <Link to={`/book/book-Volumes?bookName=${bookName}`}> */}
        <button
          disabled={createVolumeLoaderNumber}
          className="relative text-base flex justify-center items-center text-white bg-[#2a9134] disabled:bg-[#2a91349c] w-[100%] py-4 rounded-xl mb-2 px-[53px]"
          onClick={addVolumes}>
          {createVolumeLoaderNumber ? <span className="absolute">Uploaded: {createVolumeLoaderNumber}</span> : null}
          <span
            className={
              createVolumeLoaderNumber
                ? `opacity-0 flex items-center justify-center`
                : 'flex items-center justify-center'
            }>
            <TicIcon className="mr-1.5" stroke="#fff" />
            {editState ? 'UPDATE VOLUMES' : `Add Book`}
          </span>
        </button>
        {/* </Link> */}
      </div>
    </div>
  );
};

function AddBook() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [uploadedImage, setUploadedImage] = useState(false);
  const [uploadedImageName, setUploadedImageName] = useState('');
  const [uploadedLogo, setUploadedLogo] = useState(false);
  const [uploadedLogoName, setUploadedLogoName] = useState(false);
  const [stepCount, setStepCount] = useState(1);
  const [bookName, setBookName] = useState('');
  const getSingleBook = useSelector(e => e.Book.getSingleBook);
  const volumesData = useSelector(e => e.Book.volumesData);
  const [editState, setEditState] = useState(false);
  const [bookId, setBookId] = useState('');
  const [bookDetail, setBookDetail] = useState({
    bookName: '',
    banner: false,
    logo: false,
  });
  const [volumes, setVolumes] = useState([
    {
      volume_name: '',
      pdf_file: '',
      pdfName: '',
      volumne_number: 0,
      all_in_one: true,
    },
    {
      volume_name: '',
      pdf_file: '',
      pdfName: '',
      volumne_number: 1,
      all_in_one: false,
    },
  ]);
  const [allVolume, setAllVolume] = useState({
    volume_name: '',
    pdf_file: '',
    pdfName: '',
    all_in_one: true,
  });

  const AddMoreVolume = () => {
    let arr = [...volumes];
    if (arr[arr.length - 1].volume_name && arr[arr.length - 1].pdf_file) {
      arr.push({
        volume_name: '',
        pdf_file: '',
        pdfName: '',
        volumne_number: volumes.length,
        all_in_one: false,
      });
      setVolumes(arr);
    } else {
      toast.error('Please fill all previous volume fields');
    }
  };
  const clearStates = (step, back) => {
    setUploadedImage(false);
    setUploadedImageName('');
    setUploadedLogo(false);
    setUploadedLogoName(false);
    setStepCount(step ? step : 1);
    setBookName('');
    setBookDetail({
      bookName: '',
      banner: false,
      logo: false,
    });
    setVolumes([
      {
        volume_name: '',
        pdf_file: '',
        pdfName: '',
        volumne_number: 0,
        all_in_one: true,
      },
      {
        volume_name: '',
        pdf_file: '',
        pdfName: '',
        volumne_number: 1,
        all_in_one: false,
      },
    ]);
    setAllVolume({
      volume_name: '',
      pdf_file: '',
      pdfName: '',
    });
    if (back) {
      navigate('/');
    }
  };

  const addBook = () => {
    if (bookName && uploadedImage && uploadedLogo) {
      let obj = {
        bookName: bookName,
        cover_img: uploadedImage,
        logo_img: uploadedLogo,
        status: 'pending',
      };
      // dispatch(createBookAction(obj, clearStates, editState, navigate))
      dispatch(createBookAction(obj, setStepCount, setBookId));
    } else {
      toast.error('book name and cover image is required');
    }
  };

  const addVolumes = () => {
    const url = new URL(window.location);
    const bookID = url.searchParams.get('book');
    // if (volumes[volumes.length - 1].volume_name && volumes[volumes.length - 1].pdf_file) {

    let data = allVolume.volume_name ? [allVolume, ...volumes] : volumes;
    dispatch(
      createVolumeAction(
        data.filter(obj => obj.volume_name),
        navigate,
        clearStates,
        bookId,
        bookID
      )
    );
    toast.success(editState ? 'Book updated' : 'Book Added');
    // }
    //  else {
    //   toast.error('Please fill all previous volume fields');
    // }
  };

  useEffect(() => {
    const url = new URL(window.location);
    const bookID = url.searchParams.get('book');
    const step = url.searchParams.get('step');

    if (bookID) {
      clearStates();
      // setEditState(true);
      dispatch(getSingleBookAction(bookID));
      dispatch(getBookVolumesAction(bookID));
    } else {
      clearStates();
      dispatch(getSingleBookData(false));
      dispatch(getBookVolumesData(false));

      setEditState(false);
    }
  }, []);
  useEffect(() => {
    if (getSingleBook || volumesData.length) {
      setEditState(getSingleBook);
      setBookName(getSingleBook.bookName);
      if (volumesData.length) {
        // setAllVolume(volumesData[0])
        // setVolumes([

        //     {
        //         volume_name: '',
        //         pdf_file: '',
        //         pdfName: '',
        //         all_in_one: true

        //     },
        //     {
        //         volume_name: '',
        //         pdf_file: '',
        //         pdfName: '',
        //         all_in_one: false

        //     }
        // ])
        if (volumesData.filter(obj => obj.all_in_one).length) {
          setVolumes(volumesData);
        } else {
          setVolumes([
            {
              volume_name: '',
              pdf_file: '',
              pdfName: '',
              volumne_number: 0,
              all_in_one: true,
            },
            ...volumesData,
          ]);
        }
      }
      (async () => {
        setBookDetail({
          bookName: getSingleBook.bookName,
          banner: getSingleBook.cover_img,
          logo: getSingleBook.logo_img,
        });
        let fileCover;
        let fileLogo;

        if (getSingleBook) {
          fileCover = await URLToFile(
            getSingleBook.cover_img_url ? getSingleBook.cover_img_url : `${assetURL}${getSingleBook.cover_img}`
          );

          fileLogo = await URLToFile(
            getSingleBook.logo_img_url ? getSingleBook.logo_img_url : `${assetURL}${getSingleBook.logo_img}`
          );
        }
        const url = new URL(window.location);
        const bookID = url.searchParams.get('book');
        if (bookID) {
          setUploadedImage(fileCover);
          setUploadedImageName(getSingleBook.cover_img);
          setUploadedLogo(fileLogo);
          setUploadedLogoName(getSingleBook.logo_img);
        }
      })();
    } else {
      setEditState(false);
      clearStates();
    }
  }, [getSingleBook, volumesData]);

  const updateBook = () => {
    let obj = {};
    if (bookDetail.banner === editState.cover_img && bookDetail.logo === editState.logo_img) {
      obj = {
        bookName: bookName,
        // cover_img: bookDetail.banner,
      };
    } else if (bookDetail.banner !== editState.cover_img && bookDetail.logo === editState.logo_img) {
      obj = {
        bookName: bookName,
        cover_img: bookDetail.banner,
        coverEdit: true,
        logoEdit: false,
      };
    } else if (bookDetail.banner === editState.cover_img && bookDetail.logo !== editState.logo_img) {
      obj = {
        bookName: bookName,
        logo_img: bookDetail.logo,
        logoEdit: true,
        coverEdit: false,
      };
    } else if (bookDetail.banner !== editState.cover_img && bookDetail.logo !== editState.logo_img) {
      obj = {
        bookName: bookName,
        cover_img: bookDetail.banner,
        logo_img: bookDetail.logo,
        coverEdit: true,
        logoEdit: true,
      };
    }
    dispatch(updateBookAction(obj, editState._id));
  };

  return (
    <div className="AddBook my-12 px-8 innerDashboard">
      <div className="header  justify-between flex">
        <div className="flex align-middle items-center">
          <div className="flex items-center">
            <button
              className="bg-[#eef2f0] flex items-center justify-center w-[48px] h-[48px] rounded-xl mr-4"
              onClick={() => {
                if (stepCount === 2) {
                  setStepCount(1);
                } else {
                  clearStates(stepCount, true);
                }
              }}>
              <BackIcon />
            </button>
            <h2 className="text-[32px] font-extrabold">Add New Book</h2>
          </div>
        </div>
        <p className="text-2xl font-extrabold">{stepCount}/2</p>
      </div>
      {stepCount === 1 ? (
        <StepOne
          addBook={addBook}
          setBookName={setBookName}
          setUploadedImage={setUploadedImage}
          setUploadedImageName={setUploadedImageName}
          setBookDetail={setBookDetail}
          uploadedImageName={uploadedImageName}
          uploadedImage={uploadedImage}
          bookDetail={bookDetail}
          bookName={bookName}
          setStepCount={setStepCount}
          setUploadedLogo={setUploadedLogo}
          setUploadedLogoName={setUploadedLogoName}
          uploadedLogo={uploadedLogo}
          uploadedLogoName={uploadedLogoName}
          editState={editState}
          updateBook={updateBook}
        />
      ) : (
        <StepTwo
          volumes={volumes}
          setVolumes={setVolumes}
          AddMoreVolume={AddMoreVolume}
          allVolume={allVolume}
          setAllVolume={setAllVolume}
          bookDetail={bookDetail}
          bookName={bookName}
          addVolumes={addVolumes}
          editState={editState}
        />
      )}
    </div>
  );
}

export default AddBook;

// [

//     {
//         bookName:'asdd',
//         categoryName:'dsad',
//         _id:1
//     }
//     {
//         bookName:'asdd',
//         categoryName:'dsad',
//         _id:2
//     }
//     {
//         bookName:'asdd',
//         categoryName:'dsad',
//         _id:3
//     }
//     {
//         bookName:'asdd',
//         categoryName:'dsad',
//         _id:4
//     }
//     {
//         bookName:'asdd',
//         categoryName:'dsad',
//         refCatId: 1
//         _id:5
//     }
//     {
//         bookName:'asdd',
//         categoryName:'dsad',
//         refCatId: 1
//         _id:6
//     }
//     {
//         bookName:'asdd',
//         categoryName:'dsad',
//         refCatId: 2
//         _id:7
//     }
//         {
//         bookName:'asdd',
//         categoryName:'dsad',
//         refCatId: 5
//         _id:8
//     }
// ]
